<template>
  <div class="component">
    <div class="simplified-title text-center mb-5">
      <h1 v-html="trans(`general.space_setup.observation_methodology`)"></h1>
    </div>

    <list-provider
        class="w-100"
        url="/store-products"
        :params="{include: 'variant'}"
        v-on="$listeners"
        v-on:data-loaded="productsLoaded">
      <template #default="list">
        <div v-for="item in list" :key="item.id">
          <product-card-inline :product="item" v-on:installed="stepDone"/>
        </div>
        <div class="d-flex justify-content-center mt-3" v-if="Object.keys(list).length">
          <basic-input v-model="skipPresets" type="checkbox"
                       :label="trans('general.setup_widget.observations_step.skip_presets')"/>
        </div>
      </template>
      <template #noContent="list">
        <no-content-placeholder
            v-if="list.length === 0 && !loading"
            :title="'No products to install'"
            :text="trans('general.settings.no_presets_to_install')"/>
      </template>
    </list-provider>

    <setup-footer ref="setupFooter" :step="step" @nextStep="handleNextStep" v-on="$listeners"/>
  </div>
</template>

<script>
import SetupFooter from "../molecules/SetupFooter.vue";
import ListProvider from "../../../theme/molecules/ListProvider.vue";
import ProductCardInline from "../../StoreWidget/molecules/ProductCardInline.vue";
import NoContentPlaceholder from "../../../theme/organisms/NoContentPlaceholder.vue";
import BasicInput from "../../../theme/atoms/BasicInput.vue";

export default {
  name: "SelectObservation",
  props: {
    props: Object,
    step: {
      type: Number
    }
  },
  components: {
    BasicInput,
    ProductCardInline,
    ListProvider,
    SetupFooter,
    NoContentPlaceholder,
  },
  data() {
    return {
      loading: true,
      skipPresets: false
    }
  },
  methods: {
    loadData() {
      axios.get(`/development-reports`, {params: {limit: 1}})
          .then((result) => {
            if (result.data.data.data.length > 0) {
              this.$refs.setupFooter.showNextStep = true;
            }
          });
    },
    stepDone() {
      this.$refs.setupFooter.showNextStep = true;
      this.$emit('stepDone');
    },
    setFooterBtnText(state) {
      this.$refs.setupFooter.setButtonText(state);
    },
    productsLoaded(data) {
      this.loading = false;
      if (data.data.length === 0) {
        this.$refs.setupFooter.showNextStep = true;
      }
    },
    handleNextStep() {
      if (this.skipPresets) {
        this.stepDone();
      }
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>
